import { useRef, useState } from "react";

export default function BeforeAfter({ before, after }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const handleMove = (clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const x = clientX - rect.left;
    setPos(Math.max(0, Math.min(100, (x / rect.width) * 100)));
  };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      className="relative w-full aspect-[16/9] select-none overflow-hidden rounded-2xl border border-sky-100 shadow-xl shadow-sky-100"
      onMouseMove={(e) => dragging.current && handleMove(e.clientX)}
      onMouseUp={() => (dragging.current = false)}
      onMouseLeave={() => (dragging.current = false)}
      onTouchMove={(e) => handleMove(e.touches[0].clientX)}
    >
      <img src={after} alt="after" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img
          src={before}
          alt="before"
          className="absolute inset-0 h-full object-cover"
          style={{ width: ref.current ? ref.current.getBoundingClientRect().width : "100%", maxWidth: "none" }}
        />
      </div>
      <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-md px-3 py-1 text-[10px] uppercase tracking-[0.2em] text-slate-700 rounded-full border border-sky-100">
        Sebelum
      </div>
      <div className="absolute top-4 right-4 bg-sky-500 px-3 py-1 text-[10px] uppercase tracking-[0.2em] text-white font-semibold rounded-full">
        Sesudah
      </div>
      <div
        className="compare-handle"
        style={{ left: `${pos}%` }}
        onMouseDown={() => (dragging.current = true)}
        onTouchStart={() => (dragging.current = true)}
      />
    </div>
  );
}
